import { ApiResponse } from "interfaces/models/api";
import { NeptuneArea } from "interfaces/models/area";
import { axiosECS } from "services/baseAxios";
import { validateBodyReq, validateListString } from "utils/common";

const path = "/v2/areas";

export const getNeptuneAreaList = async (
  bimFileId: string
): Promise<ApiResponse<NeptuneArea[]>> => {
  return axiosECS.get(path, {
    params: { bimFileId: encodeURIComponent(bimFileId || "") },
  });
};

export const createNeptuneArea = async (body: {
  bimFileId: string;
  version: number;
}) => {
  return axiosECS.post(path, body);
};

export const updateNeptuneArea = async (
  area: NeptuneArea
): Promise<ApiResponse<NeptuneArea>> => {
  return axiosECS.patch(path, validateBodyReq(area));
};

export const deleteNeptuneAreaList = async (
  ids: string[]
): Promise<ApiResponse<any[]>> => {
  return axiosECS.delete(path, {
    data: { ids: validateListString(ids) },
  });
};
